<template>
	<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-data-table id="content" class="elevation-1" :headers="headers" :items="companies" hide-default-footer :loading="loading" :items-per-page="-1">
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">جدول الشركات</v-toolbar-title>
						<v-divider insert vertical></v-divider>
						<v-spacer></v-spacer>
						<v-btn class="primary" :disabled="!privs.new" @click="addCompany">إضافة شركة جديدة </v-btn>
					</v-toolbar>
				</template>

				<template #[`item.logoPath`]="{ item }">
					<v-avatar v-if="item.logoPath == null" size="32">
						<v-img contain src="https://www.w3schools.com/w3images/avatar2.png"></v-img>
					</v-avatar>
					<v-avatar v-else size="32">
						<v-img contain :src="item.logoPath"></v-img>
					</v-avatar>
				</template>

				<template #[`item.webLink`]="{ item }">
					<a :href="item.webLink" target="_blank" rel="noopener noreferrer">
						{{ item.webLink }}
					</a>
				</template>

				<template #[`item.actions`]="{ item }">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn icon :disabled="!privs.manage" v-on="on" @click="editRecord(item)">
								<v-icon medium color="primary">mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>تعديل</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn icon :disabled="!privs.delete" v-on="on" @click="deleteRecord(item)">
								<v-icon medium color="error">mdi-trash-can-outline</v-icon>
							</v-btn>
						</template>
						<span>حذف</span>
					</v-tooltip>
				</template>
			</v-data-table>

			<app-confirmation-dialog ref="confirm"></app-confirmation-dialog>
		</v-container>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import { addBaseURL } from "@/utils/baseURL";

export default {
	components: {
		AppConfirmationDialog: () => import(/* webpackChunkName: "app-confirmation-dialog" */ "@/components/AppConfirmationDialog"),
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الشركات', exact: true, to: { name: "dashboard-companies" } },
				{ text: 'التحكم', disabled: true }
			],
			loading: true,
			headers: [
				{ text: "", value: "logoPath", sortable: false },
				{ text: "اسم الشركة", value: "name", sortable: false },
				{ text: "الرتبة", value: "rankID", sortable: true },
				{ text: "البريد الإلكتروني", value: "email", sortable: false },
				{ text: "رقم الهاتف", value: "phoneNumber", sortable: false },
				{ text: "الوصف", value: "description", sortable: false },
				{ text: "الرابط", value: "webLink", sortable: false },
				{ text: "العمليات", value: "actions", sortable: false }
			],
			companies: [],
		}
	},
	mounted() {
		this.getCompanies();
		this.getPrivileges();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/companiesIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCompanies() {
			client
				.get("/api/companies/all" )
				.then(resoponse => {
					this.companies = Object.values(resoponse.data.data).map(company => {
						company.logoPath = addBaseURL(company.logoPath);
						const invalidPaths = [
							"https://ertiqa.v2.svod.app/storage/لايوجد",
							"https://ertiqa.v2.svod.app/storage",
						];
						if (invalidPaths.includes(company.logoPath)) {
							company.logoPath = null;
						}
						return company;
					});
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		},
		addCompany() {
			this.$router.push({ name: "companies-add" });
		},
		editRecord(item){
			this.$router.push({ name: "companies-edit", params:{
				recordID: item.id
			} });
		},
		async deleteRecord(item) {
			const confirmed = await this.$refs.confirm.open({
				title: "تأكيد الحذف",
				message: "هل تريد حقاً حذف هذه الشركة" 
			});
			if (!confirmed) return

			this.loading = true;
			clientNotifier
				.delete("/api/companies/delete/" + item.id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					
					const index = this.companies.findIndex(company => company.id == item.id);
					if (index != -1) {
						this.companies.splice(index, 1);
					}					
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>
